import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {CardTitle} from '@hconnect/uikit/src/lib2'
import {Stack, Typography} from '@mui/material'
import React from 'react'

interface SalesForecastUploadStepHeaderProps {
  title: string
  subtitle?: string
}

export const SalesForecastUploadStepHeader: React.FC<SalesForecastUploadStepHeaderProps> = ({
  title,
  subtitle
}) => {
  return (
    <Stack {...dataTestId('sales_forecast_upload_step_header')}>
      <CardTitle variant="h3" mb={0}>
        {title}
      </CardTitle>
      <Typography variant="caption">{subtitle}</Typography>
    </Stack>
  )
}
